import slug from "../slug";

function groupCategoriesByParent(categories) {
  const categoryMap = {};
  const rootCategories = [];

  categories.forEach(category => {
    category.children = [];
    categoryMap[category.id] = category;
  });

  categories.forEach(category => {
    if (category.parent_id === "" || category.parent_id === null) {
      category.parent_id = null;
    }

    if (category.parent_id === null) {
      rootCategories.push(category);
    } else {
      const parent = categoryMap[category.parent_id];
      if (parent) {
        parent.children.push(category);
      }
    }
  });

  return createCFTags(rootCategories);
}

const createCFTags = function (rootCategories) {
  const cfTags = [
    {
      'tag': 'cf-robot-message',
      'type': 'text',
      'name': 'welcome',
      'cf-questions': 'Bienvenue au service client Orange RDC !',
    },
    {
      'tag': 'select',
      'type': 'text',
      'name': 'category',
      'cf-questions': 'Choisissez la categorie de la requête ?',
      "children": rootCategories.map(root => ({
        "tag": "option",
        "cf-label": root.title,
        "value": "category_" + slug(root.title),
      })),
    },
  ];

  for (const categorie of rootCategories) {
    if (categorie.children.length !== 0) {
      cfTags.push({
        'tag': 'select',
        'type': 'text',
        'name': 'objet',
        "cf-conditional-category": "category_" + slug(categorie.title),
        'cf-questions': "Choisissez le sujet de la requête ",
        "children": categorie.children.map(ch => ({
          "tag": "option",
          "cf-label": ch.title,
          "value": "objet_" + slug(ch.title),
        })),
      });

      for (const sc of categorie.children) {
        if (sc.children.length !== 0) {
          cfTags.push({
            'tag': 'select',
            'type': 'text',
            'name': 'reason',
            "cf-conditional-category": "category_" + slug(categorie.title),
            "cf-conditional-objet": "objet_" + slug(sc.title),
            'cf-questions': "Choisissez le motif de la requête ",
            "children": sc.children.map(ch => ({
              "tag": "option",
              "cf-label": ch.title,
              "value": "reason_" + slug(ch.title),
            })),
          });

          for (const ssc of sc.children) {
            if (ssc.children.length !== 0) {
              cfTags.push({
                'tag': 'select',
                'type': 'text',
                'name': 'sub_reason',
                "cf-conditional-category": "category_" + slug(categorie.title),
                "cf-conditional-objet": "objet_" + slug(sc.title),
                "cf-conditional-reason": "reason_" + slug(ssc.title),
                'cf-questions': "Choisissez la raison de la requête ",
                "children": ssc.children.map(ch => ({
                  "tag": "option",
                  "cf-label": ch.title,
                  "value": "sub_reason_" + slug(ch.title),
                })),
              });

              for (const sssc of ssc.children) {
                if (sssc.children.length !== 0) {
                  cfTags.push({
                    'tag': 'select',
                    'type': 'text',
                    'name': 'reason_need',
                    "cf-conditional-category": "category_" + slug(categorie.title),
                    "cf-conditional-objet": "objet_" + slug(sc.title),
                    "cf-conditional-reason": "reason_" + slug(ssc.title),
                    "cf-conditional-sub_reason": "sub_reason_" + slug(sssc.title),
                    'cf-questions': "Choisissez le besoin de la requête ",
                    "children": sssc.children.map(ch => ({
                      "tag": "option",
                      "cf-label": ch.title,
                      "value": "reason_need_" + slug(ch.title),
                    })),
                  });

                  for (const ssssc of sssc.children) {
                    if (ssssc.children.length !== 0) {
                      cfTags.push({
                        'tag': 'select',
                        'type': 'text',
                        'name': 'sub_reason_need',
                        "cf-conditional-category": "category_" + slug(categorie.title),
                        "cf-conditional-objet": "objet_" + slug(sc.title),
                        "cf-conditional-reason": "reason_" + slug(ssc.title),
                        "cf-conditional-sub_reason": "sub_reason_" + slug(sssc.title),
                        "cf-conditional-reason_need": "reason_need_" + slug(ssssc.title),
                        'cf-questions': "Choisissez le besoin de la requête ",
                        "children": ssssc.children.map(ch => ({
                          "tag": "option",
                          "cf-label": ch.title,
                          "value": "sub_reason_need_" + slug(ch.title),
                        })),
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  return cfTags;
};

export default groupCategoriesByParent;
